import React from 'react';
import { Card } from '../ui/card';
import { Button } from '../ui/button';
import { Square, X } from 'lucide-react';

export const ActiveTimerBanner = ({ activeTimer, timerElapsed, onStop, onCancel, formatTime }) => {
  if (!activeTimer) return null;
  return (
    <Card className="p-4 mb-6 bg-primary/10 border-primary">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-3 h-3 bg-red-500 rounded-full animate-pulse"></div>
          <div>
            <p className="font-medium">Timer Running: {activeTimer.task_title}</p>
            <p className="text-sm text-muted-foreground">Elapsed: {formatTime(timerElapsed)}</p>
          </div>
        </div>
        <div className="flex gap-2">
          <Button size="sm" onClick={onStop} className="bg-green-500 hover:bg-green-600">
            <Square className="mr-1 h-3 w-3" />
            Stop & Log
          </Button>
          <Button size="sm" variant="ghost" onClick={onCancel}>
            <X className="h-4 w-4" />
          </Button>
        </div>
      </div>
    </Card>
  );
};
